import { useState } from 'react'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Bike, Boxes, Gauge, LogOut, MapPinned, Menu, Radio, Settings, Users, Wifi, X } from 'lucide-react'
import { api, setCsrfToken } from '../api'
import type { User } from '../types'
import { CampaignBrand } from '../CampaignBrand'

const nav = [
  { to: '/visao-geral', label: 'Visão geral', icon: Gauge, roles: ['ADMIN', 'MANAGER'] },
  { to: '/pedidos', label: 'Pedidos', icon: Boxes, roles: ['ADMIN', 'MANAGER'] },
  { to: '/remessas', label: 'Remessas e rotas', icon: MapPinned, roles: ['ADMIN', 'MANAGER'] },
  { to: '/rastreamento', label: 'Operação ao vivo', icon: Radio, roles: ['ADMIN', 'MANAGER'] },
  { to: '/equipe', label: 'Equipe', icon: Users, roles: ['ADMIN'] },
  { to: '/configuracoes', label: 'Configurações', icon: Settings, roles: ['ADMIN', 'MANAGER'] },
  { to: '/minha-rota', label: 'Minha rota', icon: MapPinned, roles: ['DRIVER'] },
]

export function Layout({ user, onLogout }: { user: User; onLogout: () => void }) {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const items = nav.filter((item) => item.roles.includes(user.role))
  const logout = async () => {
    try { await api('/api/auth/logout', { method: 'POST' }) } finally {
      setCsrfToken('')
      onLogout()
      navigate('/')
    }
  }
  if (user.role === 'DRIVER') {
    return (
      <div className="driver-app-shell">
        <header className="driver-app-topbar">
          <div className="driver-app-brand"><span><Bike size={20} /></span><div><strong>Entregas</strong><small>Tainá de Paula · rota de rua</small></div></div>
          <div className="driver-app-user">{user.photoUrl ? <img className="driver-topbar-photo" src={user.photoUrl} alt={`Foto de ${user.fullName}`} /> : null}<div><strong>{user.fullName.split(' ')[0]}</strong><small>Em campo</small></div><button className="icon-button" title="Sair" aria-label="Sair" onClick={() => void logout()}><LogOut size={18} /></button></div>
        </header>
        <main className="driver-app-content"><Outlet /></main>
      </div>
    )
  }
  return (
    <div className="app-shell">
      <header className="mobile-header">
        <div className="mobile-product-brand"><CampaignBrand variant="compact" inverse /><span>Entregas</span></div>
        <button className="icon-button" aria-label="Abrir menu" onClick={() => setOpen(true)}><Menu size={20} /></button>
      </header>
      <header className="desktop-topbar">
        <div className="topbar-context"><span>Central logística</span><strong>Operação de entregas</strong></div>
        <div className="topbar-status"><span><i /> Central de entregas</span><span><Wifi size={14} /> Importação por planilha</span></div>
      </header>
      {open ? <button className="sidebar-scrim" aria-label="Fechar menu" onClick={() => setOpen(false)} /> : null}
      <aside className={`sidebar ${open ? 'sidebar-open' : ''}`}>
        <div className="sidebar-brand"><CampaignBrand variant="sidebar" inverse /><button className="icon-button sidebar-close" aria-label="Fechar" onClick={() => setOpen(false)}><X size={18} /></button></div>
        <nav aria-label="Navegação principal">
          <span className="sidebar-section-label">Operação</span>
          {items.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} onClick={() => setOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}>
              <Icon size={17} strokeWidth={1.8} /><span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-user">
          <div className="user-avatar">{user.fullName.slice(0, 1).toUpperCase()}</div>
          <div><strong>{user.fullName}</strong><small>{user.role === 'MANAGER' ? 'Gestor' : 'Administrador'}</small></div>
          <button className="icon-button" title="Sair" aria-label="Sair" onClick={() => void logout()}><LogOut size={17} /></button>
        </div>
      </aside>
      <main className="main-content" key={location.pathname}><Outlet /></main>
    </div>
  )
}
